export interface HMSPollLeaderboardSummary {
  averageScore?: number;
  averageTime?: number;
  respondedCorrectlyPeersCount?: number;
  respondedPeersCount?: number;
  totalPeersCount?: number;
}
